import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import RadioBtn from '@stories/Components/Inputs/RadioBtn/RadioBtn';
import * as React from 'react';
import S from '../List/FilterList.styles';
const SelectedRadioList = ({ title, name, onCancel, selectedFilters, selectedValue = '', onFilterChange, }) => (React.createElement(S.ItemList, null,
    React.createElement(S.Title, { disabled: !onCancel, onClick: (event) => {
            event.preventDefault();
            onCancel && onCancel();
        } },
        onCancel && React.createElement(SvgChevronLeft, null),
        title),
    React.createElement(S.RadioArea, null, selectedFilters &&
        selectedFilters?.map((filter, i) => (React.createElement(RadioBtn, { key: `selected-radio-${i}`, htmlFor: filter.value, labelText: filter.text, id: filter.value, type: "radio", name: name, value: filter.value, checked: filter.value === selectedValue, onChange: (e) => onFilterChange(e.target.value) }))))));
export default SelectedRadioList;
